import { Button, DialogV2, Typography } from '@recruit-robin/robin-theme/web-components';

import type { DefaultDialogProps } from './DefaultDialog.types';

import { useStyles } from './DefaultDialog.styles';

export const DefaultDialog = ({ isVisible, options }: DefaultDialogProps) => {
  const {
    title,
    description,
    showClose,
    cancelAction,
    confirmAction,
    onClose,
    showFooter = true,
    actionType = 'positive',
  } = options ?? {};
  const classes = useStyles();

  return (
    <DialogV2.Root isVisible={isVisible} customCss={classes.root}>
      <DialogV2.Backdrop onRequestClose={onClose} />

      <DialogV2.Content customCss={classes.content}>
        {showClose && <DialogV2.Close onRequestClose={onClose} />}

        {title && (
          <DialogV2.Header>
            <Typography variant={(v) => v.heading[2]} ellipsis>
              {title}
            </Typography>
          </DialogV2.Header>
        )}

        {description && (
          <DialogV2.Body>
            <Typography variant={(v) => v.body.long}>{description}</Typography>
          </DialogV2.Body>
        )}

        {(cancelAction || confirmAction) && showFooter && (
          <DialogV2.Footer>
            {cancelAction && (
              <Button
                style="text"
                type={actionType === 'positive' ? 'subtle1' : 'subtle2'}
                label={cancelAction.label}
                onClick={(e) => {
                  cancelAction.onClick?.(e);

                  if (!e.defaultPrevented) {
                    onClose?.();
                  }
                }}
              />
            )}
            {confirmAction && (
              <Button
                style="filled"
                type={actionType === 'positive' ? 'highlight' : 'danger'}
                label={confirmAction.label}
                onClick={(e) => {
                  confirmAction.onClick?.(e);

                  if (!e.defaultPrevented) {
                    onClose?.();
                  }
                }}
              />
            )}
          </DialogV2.Footer>
        )}
      </DialogV2.Content>
    </DialogV2.Root>
  );
};
